import { render, staticRenderFns } from "./BatchesList.vue?vue&type=template&id=549c6d91&scoped=true"
import script from "./BatchesList.vue?vue&type=script&lang=js"
export * from "./BatchesList.vue?vue&type=script&lang=js"
import style0 from "./BatchesList.vue?vue&type=style&index=0&id=549c6d91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549c6d91",
  null
  
)

export default component.exports